import { registerLicense } from '@syncfusion/ej2-base';
import { useEffect } from 'react';
import { useTenantContext } from './AppTenant';

const SyncfusionLicenseManager: React.FC = () => {
    const config = useTenantContext();
    useEffect(() => {
        if (config?.syncfusionLicenseKey) {
            registerLicense(config.syncfusionLicenseKey);
        }
    }, [config]);

    return null;
};

export default SyncfusionLicenseManager; 